<template>
  <!-- <div>ProductParameterDeformation</div> -->
  <div v-if="!readonly" class="row">
    <div v-for="(field, index) in product.fields" :key="field.id" :class="getFieldClass(field, index)">
      <label :for="field.id + '-input-number'" class="form-label text-capitalize">
        {{ field.label }}
        <a v-if="field.image" @click="$emit('infoButtonClicked', field.image)">
          <el-icon :size="15" style="position: relative; left: 2px; top: 3px">
            <InfoFilled />
          </el-icon>
        </a>
      </label>
      <input
        :id="field.id + '-input-number'"
        v-model="field.value"
        type="number"
        class="form-control"
        :min="field.min"
        :max="field.max"
        :step="field.step || 0.01"
        @change="handleChange($event, field)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator';
import { Product } from '@/types/api/Model/Product';

// Define the Field interface
interface Field {
  id: string;
  label: string;
  type: string;
  show: boolean;
  fullColumn?: boolean;
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  image?: string;
}

@Component({
  components: {},
  emits: ['updateField'],
})

export default class ProductParameterDeformation extends Vue {
  @Prop() properties!: any[];
  @Prop({ default: false }) readonly!: boolean;
  @Prop() product!: Product & { fields: Field[] };

  height = 1;

  handleChange(event: Event, field: Field) {
    const value = Number((event.target as HTMLInputElement).value);
    this.$emit('updateField', { id: field.id, value });
  }

  getFieldClass(field: Field, index: number): string {
    // Jika field memang harus tampil penuh (fullColumn)
    if (field.fullColumn) return 'col-sm-12 mb-3 ps-4';

    // Ambil semua index field yang bukan fullColumn
    const nonFullColumnIndexes = this.product.fields.map((field, index) => (!field.fullColumn ? index : -1)).filter((index) => index !== -1);

    const isOddCount = nonFullColumnIndexes.length % 2 === 1;
    const isLastNonFull = index === nonFullColumnIndexes.at(-1);

    // Jika jumlah field non-fullColumn ganjil dan ini adalah yang terakhir → full row
    if (isOddCount && isLastNonFull) {
      return 'col-sm-12 mb-3 ps-4';
    }

    // Sisanya → tampil dalam dua kolom
    return 'col-sm-6 mb-3';
  }
}
</script>